import React, {  useEffect, useMemo } from "react";
import noticeTypeToBackendType from "../../../constants/noticeTypeToBackendType";
import noticeTypes from "../../../constants/noticeTypes";
import { Button } from "antd";


const NoticeTypeButtons = ({openedNotice, setNoticeTypeView, noticeTypeView}) => {
  const chosenNoticeTypes = useMemo(
		() =>
			noticeTypes.filter(
				(noticeType) =>
					openedNotice?.[
						noticeTypeToBackendType[noticeType.id]
					]
			),
		[noticeTypes, openedNotice]
	);

	useEffect(() => {
		if (chosenNoticeTypes?.length > 0) {
			setNoticeTypeView(chosenNoticeTypes[0].id);
		}
	}, [chosenNoticeTypes]);
	return (
		<div className="buttons_row">
			{chosenNoticeTypes.map((noticeType) => {
				return (
					<Button
						key={`${noticeType.id} ${noticeTypeView}`}
						className={`button ${
							noticeTypeView === noticeType.id
								? "primary_button"
								: "button-disabled"
						}`}
						onClick={() => setNoticeTypeView(noticeType.id)}
					>
						{noticeType.name}
					</Button>
				);
			})}
		</div>
	);
};

export default NoticeTypeButtons;
